import React, { Fragment } from 'react';
import positions from '../../../assets/images/positions.json';
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Vacant = () =>{

    const { t } = useTranslation();
    
    function ListPosition(props){
        let { id_vacant } = useParams();
        const positions = props.positions;
        const position = positions.find(pos => pos.id === parseInt(id_vacant));
        let listItems = '';
        if(typeof position !== "undefined"){
            listItems = (
                <Fragment>
                    <div Style="background-color: #083F5B" className="text-center text-white py-3">
                        <h2 className="text-3xl font-bold pt-4 lg:pt-0">{t("position.title."+position.id)}</h2>
                    </div>
                    <div className="text-justify p-4">
                        <h3 className="text-2xl font-semibold">{t("position.description.title")}</h3>
                        <p className="pt-4 text-sm" dangerouslySetInnerHTML={{__html: t("position.description."+position.id) }}></p>
                    </div>
                    <div className="text-justify p-4">
                        <h3 className="text-2xl font-semibold">{t("position.research_topic.title")}</h3>
                        <p className="pt-4 text-sm" dangerouslySetInnerHTML={{__html: t("position.research_topic."+position.id) }}></p>
                    </div>
                    {t("position.conditions.title").length < 1 &&
                        <div className="text-justify p-4">
                            <h3 className="text-2xl font-semibold">{t("position.conditions.title")}</h3>
                            <p className="pt-4 text-sm" dangerouslySetInnerHTML={{__html: t("position.conditions."+position.id) }}></p>
                        </div>
                    }
                    <div className="text-justify p-4">
                        <h3 className="text-2xl font-semibold">{t("position.requirements.title")}</h3>
                        <p className="pt-4 text-sm break-words" dangerouslySetInnerHTML={{__html: t("position.requirements."+position.id) }}></p>
                    </div>
                    <div className="text-justify p-4">
                        <h3 className="text-2xl font-semibold">{t("position.aplication_date.title")}</h3>
                        <p className="pt-4 text-sm" dangerouslySetInnerHTML={{__html: t("position.aplication_date."+position.id) }}></p>
                    </div>
                    <div className="text-justify p-4">
                        <h3 className="text-2xl font-semibold">{t("position.promotor.title")}</h3>
                        <p className="pt-4 text-sm" dangerouslySetInnerHTML={{__html: t("position.promotor."+position.id) }}></p>
                    </div>
                    <div className="text-justify p-4">
                        <h3 className="text-2xl font-semibold">{t("position.contact.title")}</h3>
                        <p className="py-4 text-sm" dangerouslySetInnerHTML={{__html: t("position.contact."+position.id) }}></p>
                    </div>
                </Fragment>
            )
        }else{
            window.location.href = 'doctorados/';
        }
        return (
            <Fragment>{listItems}</Fragment>
        );
    }

    return(
        <Fragment>
            <section className="max-w-7xl mx-auto">
                <ListPosition positions={positions}></ListPosition>
            </section>
        </Fragment>
    )
}

export default Vacant;